var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"so-dark",attrs:{"app":"","dark":"","clipped-right":"","hide-on-scroll":""}},[_c('v-toolbar-title',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"pt-2",attrs:{"width":"85","src":require('@/assets/pearl-black.png')}})])],1),_c('division-selector'),_c('main-menu'),_c('v-spacer'),_c('logout-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }